var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
import { get } from '../utils/funcs';
import whiteLogo from '../static/fiducius-logo-lg-white.png';
import regularLogo from '../static/fiducius-logo-2.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/pro-light-svg-icons/faBars';
import Drawer from './drawer';
var StyledNavigationIcon = styled(FontAwesomeIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-left: 0.75rem;\n\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n  }\n\n  @media (min-width: 577px) {\n    display: none;\n    visibility: hidden;\n  }\n"], ["\n  margin-left: 0.75rem;\n\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n  }\n\n  @media (min-width: 577px) {\n    display: none;\n    visibility: hidden;\n  }\n"])), function (p) {
  return p.theme.themeName === 'dark' || p.theme.themeName === 'greenlight' ? p.theme.white : p.theme.themeName === 'newlight' ? p.theme.textPrimary : p.theme.primary;
}, function (p) {
  return p.theme.themeName === 'dark' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.themeName === 'greenlight' ? p.theme.highContrast : p.theme.primary;
});
var Nav = styled.nav(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: ", " solid ", ";\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n  height: ", ";\n  align-items: center;\n  width: 100%;\n\n  @media (max-width: 576px) {\n    background-color: ", ";\n    background: linear-gradient(0deg, ", " 0%, ", " 100%);\n  }\n"], ["\n  background-color: ", ";\n  border-bottom: ", " solid ", ";\n  color: ", ";\n  display: flex;\n  flex-grow: 1;\n  height: ", ";\n  align-items: center;\n  width: 100%;\n\n  @media (max-width: 576px) {\n    background-color: ", ";\n    background: linear-gradient(0deg, ", " 0%, ", " 100%);\n  }\n"])), function (p) {
  return p.theme.level3;
}, function (p) {
  return p.theme.borderWidth;
}, function (p) {
  return p.theme.level3;
}, function (p) {
  return p.theme.highContrast;
}, function (p) {
  return p.theme.topBarHeight;
}, function (p) {
  return p.theme.level1;
}, function (p) {
  return p.theme.level1B;
}, function (p) {
  return p.theme.level1;
});
var NavAction = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  height: 100%;\n  padding: 0 1.25rem;\n  &.active {\n    border: 0;\n    border-bottom: 3px solid ", ";\n    box-shadow: none;\n    color: ", ";\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  height: 100%;\n  padding: 0 1.25rem;\n  &.active {\n    border: 0;\n    border-bottom: 3px solid ", ";\n    box-shadow: none;\n    color: ", ";\n  }\n"])), function (p) {
  return p.theme.primary;
}, function (p) {
  return p.theme.primary;
});
var NavActions = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  list-style: none;\n  margin-left: 2rem;\n"], ["\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  list-style: none;\n  margin-left: 2rem;\n"])));
var NavLinks = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-start;\n\n  & > h5 {\n    font-weight: ", ";\n    margin: 0 2rem 0 0.5rem;\n  }\n\n  @media (max-width: 576px) {\n    visibility: hidden;\n    width: 0px;\n  }\n"], ["\n  display: flex;\n  flex-grow: 1;\n  justify-content: flex-start;\n\n  & > h5 {\n    font-weight: ", ";\n    margin: 0 2rem 0 0.5rem;\n  }\n\n  @media (max-width: 576px) {\n    visibility: hidden;\n    width: 0px;\n  }\n"])), function (p) {
  return p.theme.fontWeightNormal;
});
var Logo = styled.img(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  align-self: center;\n  height: auto;\n  max-height: calc(", " - 0.5rem);\n  max-width: 100%;\n"], ["\n  align-self: center;\n  height: auto;\n  max-height: calc(", " - 0.5rem);\n  max-width: 100%;\n"])), function (p) {
  return p.theme.topBarHeight;
});
var LogoWrapper = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-start;\n  ", ";\n  padding: 0.25rem 1rem;\n\n  @media (min-width: 577px) {\n    display: none;\n    visibility: hidden;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-start;\n  ", ";\n  padding: 0.25rem 1rem;\n\n  @media (min-width: 577px) {\n    display: none;\n    visibility: hidden;\n  }\n"])), function (p) {
  return p.theme.sidebarWidthAdjust('width', p);
});

var getLogo = function getLogo(p, defaultLogo) {
  if (defaultLogo !== whiteLogo) {
    return defaultLogo;
  } else {
    return p !== 'light' && p !== 'newlight' ? whiteLogo : regularLogo;
  }
};

var NavTop = function NavTop(_a) {
  var actions = _a.actions,
      links = _a.links,
      theme = _a.theme,
      _b = _a.logo,
      logo = _b === void 0 ? whiteLogo : _b,
      sidebar = _a.sidebar,
      navigationOpen = _a.navigationOpen,
      toggleNavigation = _a.toggleNavigation;
  return React.createElement(Nav, {
    className: "nav-top navbar"
  }, React.createElement(StyledNavigationIcon, {
    key: "leftNav",
    icon: faBars,
    size: "2x",
    onClick: function onClick() {
      return toggleNavigation();
    }
  }), React.createElement(LogoWrapper, {
    className: "navbar-logo"
  }, React.createElement(Logo, {
    src: getLogo(theme, logo),
    alt: "Fiducius Logo"
  })), React.createElement(NavLinks, {
    className: "navbar-links"
  }, links), React.createElement(NavActions, {
    className: "navbar-actions"
  }, React.Children.map(actions, function (action) {
    return React.createElement(NavAction, get(action, 'props', {}), action);
  })), React.createElement(Drawer, {
    isOpen: navigationOpen,
    align: "left"
  }, sidebar));
};

export default NavTop;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;